import { render } from "./TouchableAlert.vue?vue&type=template&id=66b96ad8&ts=true"
import script from "./TouchableAlert.vue?vue&type=script&lang=ts"
export * from "./TouchableAlert.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__